import React from 'react';
import PropTypes from 'prop-types';
import { Button as BSButton } from 'react-bootstrap';
import classNames from 'classnames';

function Button({ children, primary, ...other }) {
  return (
    <BSButton variant={classNames({ primary, default: !primary })} {...other}>
      {children}
    </BSButton>
  );
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  primary: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/js/components/ui/Button.jsx